
/**
 * Created by Daniel 11/26/2019
 * Description:
 *
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WidgetsModule } from '../../widgets/widgets.module';
import { AttachmentListModule } from '../attachment-list/attachment-list.module';
import { NoteDetailModule } from '../note-detail/note-detail.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ThreadSideSheetComponent } from './thread-side-sheet.component';
import { MapTileDialogModule } from '../map-tile-dialog/map-tile-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        AttachmentListModule,
        NoteDetailModule,
        TooltipModule,
        MapTileDialogModule
    ],
    declarations: [
        ThreadSideSheetComponent,
    ],
    exports: [
        ThreadSideSheetComponent,
    ]
})
export class ThreadSideSheetModule { }
